import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RequireAuth } from "@/components/RequireAuth";
import { Layout } from "@/components/layout/Layout";

import Home from "@/pages/Home";
import Listings from "@/pages/Listings";
import ListingDetail from "@/pages/ListingDetail";
import Categories from "@/pages/Categories";
import { Wholesale, Agriculture } from "@/pages/SpecialSections";
import CorporateSellers from "@/pages/CorporateSellers";
import SellerProfile from "@/pages/SellerProfile";
import BuyRequests from "@/pages/BuyRequests";
import BuyRequestDetail from "@/pages/BuyRequestDetail";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordPages";
import AuthCallback from "@/pages/AuthCallback";

import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import {
  Overview, MyListings, OffersReceived, OffersSent, MyBuyRequests, Favorites, Profile, Settings, SavedSearches,
} from "@/pages/dashboard/DashboardPages";
import Messages from "@/pages/dashboard/Messages";
import ListingWizard from "@/pages/dashboard/ListingWizard";

import AdminLayout from "@/pages/admin/AdminLayout";
import {
  AdminOverview, AdminUsers, AdminCorporate, AdminListings, AdminCategories,
  AdminBuyRequests, AdminReports, AdminMessages, AdminFeatured,
} from "@/pages/admin/AdminPages";

function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <p className="font-display text-6xl font-extrabold text-emerald-900">404</p>
      <p className="text-slate-500">Aradığınız sayfa bulunamadı.</p>
      <Link to="/" className="rounded-full bg-emerald-600 px-5 py-2 font-semibold text-white hover:bg-emerald-700">Ana Sayfaya Dön</Link>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            {/* Auth (standalone) */}
            <Route path="/giris" element={<Login />} />
            <Route path="/kayit" element={<Register />} />
            <Route path="/sifremi-unuttum" element={<ForgotPassword />} />
            <Route path="/sifre-sifirla" element={<ResetPassword />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            {/* Admin */}
            <Route path="/admin" element={<RequireAuth adminOnly><AdminLayout /></RequireAuth>}>
              <Route index element={<AdminOverview />} />
              <Route path="kullanicilar" element={<AdminUsers />} />
              <Route path="kurumsal" element={<AdminCorporate />} />
              <Route path="ilanlar" element={<AdminListings />} />
              <Route path="kategoriler" element={<AdminCategories />} />
              <Route path="alim-talepleri" element={<AdminBuyRequests />} />
              <Route path="sikayetler" element={<AdminReports />} />
              <Route path="mesajlar" element={<AdminMessages />} />
              <Route path="one-cikan" element={<AdminFeatured />} />
            </Route>

            {/* Public + dashboard (with header/footer) */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/ilanlar" element={<Listings />} />
              <Route path="/ilan/:id" element={<ListingDetail />} />
              <Route path="/kategoriler" element={<Categories />} />
              <Route path="/toptan-firsatlar" element={<Wholesale />} />
              <Route path="/tarlada-kalanlar" element={<Agriculture />} />
              <Route path="/kurumsal-saticilar" element={<CorporateSellers />} />
              <Route path="/satici/:id" element={<SellerProfile />} />
              <Route path="/alim-talepleri" element={<BuyRequests />} />
              <Route path="/alim-talepleri/:id" element={<BuyRequestDetail />} />

              <Route path="/panel" element={<RequireAuth><DashboardLayout /></RequireAuth>}>
                <Route index element={<Overview />} />
                <Route path="ilanlarim" element={<MyListings />} />
                <Route path="yeni-ilan" element={<ListingWizard />} />
                <Route path="ilan-duzenle/:id" element={<ListingWizard />} />
                <Route path="mesajlar" element={<Messages />} />
                <Route path="teklifler" element={<OffersReceived />} />
                <Route path="tekliflerim" element={<OffersSent />} />
                <Route path="alim-taleplerim" element={<MyBuyRequests />} />
                <Route path="favoriler" element={<Favorites />} />
                <Route path="aramalar" element={<SavedSearches />} />
                <Route path="profil" element={<Profile />} />
                <Route path="ayarlar" element={<Settings />} />
              </Route>

              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
